<template>
  <div class="propertyTemplate">
<!--    <el-card>-->
<!--      <el-breadcrumb separator="/">-->
<!--        <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item>商品属性</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item>模板管理</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </el-card>-->
    <main class="content">
      <el-card>
        <el-form :inline="true" :model="searchForm" size="mini">
          <el-form-item label="模板名称">
            <el-input v-model="searchForm.name" placeholder="模板名称" size="mini" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="模板状态" size="mini" clearable>
              <el-option label="全部" value></el-option>
              <el-option label="无效" value="0"></el-option>
              <el-option label="有效" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
        <div ref="tablePosition"></div>
        <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" size="mini" :height="tableConfig.height">
          <el-table-column prop="name" label="模板名称" width="300"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status ===  1 ? 'primary' : 'info'"
                disable-transitions
              >{{scope.row.status === 1 ? "有效" : "无效" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350" align="right">
            <template slot="header">
              <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleEditProperty(scope.$index, scope.row)" v-if="scope.row.canEdit">编辑属性</el-button>

              <el-button type="text" size="mini" @click="handleViewProperty(scope.$index, scope.row)" v-else>查看属性</el-button>
              <el-divider direction="vertical" ></el-divider>
              <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
              <el-divider direction="vertical" ></el-divider>
              <el-button type="text" size="mini" :disabled="!scope.row.canEdit" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;padding-top: 20px">
          <el-pagination
            background
            layout="sizes,prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            v-if="total>0"
            :total="total"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="onPageChange"
            :current-page="currentPage"
            @prev-click="onPageChange"
            @next-click="onPageChange"
          ></el-pagination>
        </div>
      </el-card>
    </main>
    <el-dialog title="属性模板" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editForm.description" placeholder="请输入描述" clearable></el-input>
        </el-form-item>
        <el-form-item label="上级模板">
          <el-select
            v-model="editForm.fid"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入上级模板名称"
            :remote-method="loadTemplate"
            :loading="fTemplateLoading"
          >
            <el-option
              v-for="item in template"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="editForm.status" placeholder="请选择模板状态" clearable>
            <el-option label="无效" value="0"></el-option>
            <el-option label="有效" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
  data() {
    return {
      pageLoading: undefined,
      tableConfig: {
        height: 0,
      },
      searchForm: {
        name: "",
        status: ""
      },
      statusOptions: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "无效"
        },
        {
          value: "1",
          label: "有效"
        }
      ],
      fTemplateLoading: false,
      loading: false,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      editDialogVisible: false,
      editForm: {
        id: "",
        name: "",
        description: "",
        fid: "",
        status: "1"
      },
      template: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    onSearch() {
      let template = {};
      if (this.searchForm.name != "") {
        template["name"] = this.searchForm.name;
      }
      if (this.searchForm.status != "") {
        template["status"] = this.searchForm.status;
      }

      this.loading = true;
      let _this = this;
      this.$axios
        .post("/admin/property/template/search", {
          cond: template,
          page: this.currentPage - 1,size:this.pageSize
        })
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.loading = false;
            _this.tableData = resp.data.content;
            _this.total = resp.data.totalElements;
          }
        })
        .catch(function() {});
    },
    handleCreate() {
      this.editForm.id = "";
      this.editForm.name = "";
      this.editForm.description = "";
      this.editForm.fid = "";
      this.editForm.status = "1";
      this.editDialogVisible = true;
    },
    onSubmit() {
      let that = this;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$axios
            .post("/admin/property/template", this.editForm)
            .then(function(response) {
              let resp = response.data;
              if (resp.header.status == 0) {
                that.$notify({
                  title: "成功",
                  message: "数据保存成功",
                  type: "success"
                });
                that.editDialogVisible = false;
                that.onSearch();
              } else {
                that.$notify.error({
                  title: "错误",
                  message: resp.header.msg
                });
              }
            });
        }
      });
    },
    handleSizeChange(pageSize){
      this.pageSize = pageSize;
      this.onSearch();
    },
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.onSearch();
    },
    handleEditProperty(index, row) {
      this.$router.push({ name: "propertySelectProperty", params: { edit: true, templateId: row.id,title:"属性" } });
    },
    handleViewProperty(index, row) {
      this.$router.push({ name: "propertySelectProperty", params: { edit: false, templateId: row.id,title:"属性" } });
    },
    handleEdit(index, row) {
      let that = this;
      this.fTemplateLoading = true;
      this.$axios
      .post("/admin/property/template/list", {
        id: row.fid,
      })
      .then(function(response) {
        let resp = response.data;
          if (resp.header.status == 0) {
            that.fTemplateLoading = false;
            that.template = resp.data;
            that.editForm.fid = row.fid;
            that.editForm.id = row.id;
            that.editForm.name = row.name;
            that.editForm.description = row.description;
            that.editForm.status = row.status + "";
            that.editDialogVisible = true;
        }
      })
      .catch(function() {});
    },
    handleDelete(index, row) {
      let _this = this;
      this.$confirm("是否删除属性模板【" + row.name + "】？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        _this.$axios
          .delete("/admin/property/template/delete/" + row.id)
          .then(function(response) {
            let resp = response.data;
            if (resp.header.status === 0) {
              _this.$notify({
                title: "成功",
                message: "数据删除成功",
                type: "success"
              });
              _this.onSearch();
            } else {
              _this.$notify.error({
                title: "错误",
                message: resp.header.msg
              });
            }
          });
      });
    },
    loadTemplate(query) {
      if(query=="") return;
      this.fTemplateLoading = true;
      let _this = this;
      this.$axios
        .post("/admin/property/template/list", {
          name: query,
        })
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.fTemplateLoading = false;
            _this.template = resp.data;
          }
        })
        .catch(function(error) {});
    },
    setTableHeight() {
      const tablePosition = this.$refs['tablePosition'];
      const {top} = tablePosition.getBoundingClientRect();
      this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
    }
  },
  created() {
    this.onSearch();
    window.addEventListener("resize", this.setTableHeight);
  },
  mounted() {
    this.pageLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    setTimeout(() => {
      this.setTableHeight();
      this.pageLoading.close();
      this.pageLoading = undefined;
    }, 500);
  },
  beforeDestroy() {
    if(this.pageLoading){
      this.pageLoading.close();
      this.pageLoading = undefined;
    }
  },
  destroyed () {
    window.removeEventListener("resize", this.setTableHeight);
  }
};
</script>
<style>
</style>